import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListTeamsByBounty = (params) => {
  return async () => {
    const { bountyId, page, limit } = params;
    
    return client
      .api(`/report/${bountyId}/get-team-info-report`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};
